import type { QueryKey } from '@tanstack/react-query';

import type { ContactFilters } from '../../../services/appStore';

export const CONTACTS_KEY = 'contacts';

export type ContactListQueryKey = ReturnType<typeof makeContactListQueryKey>;

export const isContactListQueryKey = (queryKey: QueryKey): queryKey is ContactListQueryKey =>
  queryKey[0] === CONTACTS_KEY;

export const makeContactListQueryKey = ({
  companyLinkedinId,
  domain,
  contactFilters,
}: {
  companyLinkedinId?: string;
  domain?: string;
  contactFilters: ContactFilters;
}) => {
  const { searchText, persona, includeCountries, contactDetails, status } = contactFilters;
  const countryIds = includeCountries.map((country) => country.id);
  return [CONTACTS_KEY, companyLinkedinId, domain, searchText, persona, contactDetails, status, ...countryIds] as const;
};
